import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/importacao', { params: parametros }).then(response => response.data);
  },
  listaPrincipal: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/importacao/principal', { params: parametros }).then(response => response.data);
  },
  listaPrincipalExcel: filtros => {
    return Vue.http.get('/api/importacao/principal/excel', { params: filtros, responseType: 'blob' })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  obterPorId: id => {
    return Vue.http.get(`/api/importacao/${id}`).then(response => response.data);
  },
  liberar: id => {
    return Vue.http.put(`/api/importacao/${id}/liberar`).then(response => response.data);
  },
  permissaoLiberarImportacao: (idImportacao) => {
    return Vue.http.get(`/api/importacao/${idImportacao}/permissaoliberar`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/importacao/servico.js